import { motion } from "framer-motion";
import useStyles from "./styles";
import { useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../../component/Navbar/NavBar";
import Footer from "../../Footer/Footer";
import Button from "../../component/Button";

const NotFound = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const FooterRef = useRef(null);
  const FAQRef = useRef(null);
  const HowitworksRef = useRef(null);
  const AboutRef = useRef(null);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const handleGoHome = () => {
    navigate("/");
  };

  return (
    <>
      <Navbar
        FooterRef={FooterRef}
        HowitworksRef={HowitworksRef}
        AboutRef={AboutRef}
        FAQRef={FAQRef}
      />
      <div className={classes.root}>
        <div className={classes.margincont}>
          <div className={classes.container}>
            <motion.div
              className={classes.content}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.5 }}
            >
              <motion.div
                className={classes.errorCode}
                initial={{ scale: 0.5, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                transition={{
                  type: "spring",
                  stiffness: 200,
                  damping: 15,
                  delay: 0.2,
                }}
              >
                <motion.span
                  initial={{ y: -50, opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  transition={{ delay: 0.4, duration: 0.5 }}
                >
                  4
                </motion.span>
                <motion.span
                  className={classes.zero}
                  initial={{ scale: 0, rotate: -180 }}
                  animate={{ scale: 1, rotate: 0 }}
                  transition={{
                    type: "spring",
                    stiffness: 200,
                    damping: 10,
                    delay: 0.6,
                  }}
                >
                  0
                </motion.span>
                <motion.span
                  initial={{ y: -50, opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  transition={{ delay: 0.8, duration: 0.5 }}
                >
                  4
                </motion.span>
              </motion.div>

              <motion.h1
                className={classes.title}
                initial={{ y: 20, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ delay: 1, duration: 0.5 }}
              >
                Page Not Found
              </motion.h1>

              <motion.p
                className={classes.message}
                initial={{ y: 20, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ delay: 1.2, duration: 0.5 }}
              >
                Oops! The page you're looking for seems to have wandered off.
                <br />
                Let's get you back on track.
              </motion.p>

              <motion.div
                className={classes.buttonContainer}
                initial={{ y: 20, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ delay: 1.4, duration: 0.5 }}
              >
                <Button
                  variant="primary"
                  color="btnfontprimary"
                  buttonSize="normal"
                  buttonName="Go Back Home"
                  onClick={handleGoHome}
                />
              </motion.div>

              <motion.div
                className={classes.illustration}
                initial={{ scale: 0, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                transition={{ delay: 1.6, duration: 0.5 }}
              >
                <motion.div
                  className={classes.circle}
                  animate={{
                    scale: [1, 1.2, 1],
                    opacity: [0.3, 0.5, 0.3],
                  }}
                  transition={{
                    duration: 3,
                    repeat: Infinity,
                    ease: "easeInOut",
                  }}
                />
                <motion.div
                  className={classes.circle2}
                  animate={{
                    scale: [1, 1.3, 1],
                    opacity: [0.2, 0.4, 0.2],
                  }}
                  transition={{
                    duration: 4,
                    repeat: Infinity,
                    ease: "easeInOut",
                    delay: 0.5,
                  }}
                />
                <motion.div
                  className={classes.circle3}
                  animate={{
                    scale: [1, 1.1, 1],
                    opacity: [0.25, 0.45, 0.25],
                  }}
                  transition={{
                    duration: 3.5,
                    repeat: Infinity,
                    ease: "easeInOut",
                    delay: 1,
                  }}
                />
              </motion.div>
            </motion.div>
          </div>
        </div>
      </div>
      <div ref={FooterRef}>
        <Footer />
      </div>
    </>
  );
};

export default NotFound;
